import React, { useEffect, useState } from 'react';
import Image from '@src/packages/pro-component/schema/Image';
import SingleSelect from '@src/packages/pro-component/schema/SingleSelect';
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Row,
  Space,
  Tabs,
} from 'antd';
import _ from 'lodash';
import TableProduct from './components/TableProduct';
import Attribution from './components/Attribution';
import { LeftOutlined, PlusOutlined } from '@ant-design/icons';
import { helper } from '@src/controls/controlHelper';
import RichText from '@src/components/Widget/RichText';
import Loading from '@src/components/Loading';

const PAGE_ID = 278;

export default function ProductFormCtrl(props: any) {
  const params = props.query;
  const isUpdate = params.mode == 'update';
  const [form] = Form.useForm();
  const [pageInfo, setPageInfo] = useState<any>({});
  const [attribution, setAttribution] = React.useState([]);
  const [product, setProduct] = useState<any>({});
  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getProductInfo();
  }, []);

  const getProductInfo = async () => {
    try {
      const _pageInfo = await helper.getPage(PAGE_ID);
      setPageInfo(_pageInfo);
      const rs: any = await helper.callPageApi(_pageInfo, 'get_product_info', {
        productTypeId: params.id,
      });
      const data = rs.data.data;
      let vi: any = {},
        en: any = {},
        attribution: any[] = [];
      data.translations.map((item: any) => {
        if (item.language === 'vi')
          vi = {
            name: item.name,
            description: item.description,
            shortDescription: item.shortDescription,
          };
        if (item.language === 'en')
          en = {
            name: item.name,
            description: item.description,
            shortDescription: item.shortDescription,
          };
      });
      for (const property in data) {
        if (property === 'productDetail') {
          attribution = data.productDetail.attrs.map((item: any) => {
            return {
              id: item.id,
              property: item.name,
              values: item.attributeValues.map((att: any) => att.name),
            };
          });
        }
        if (['name', 'description', 'shortDescription'].includes(property)) {
          vi[property] = data[property];
        }
        if (property === 'productDetail') {
          data.productDetail.productDetail.forEach((element: any) => {
            let key = [];
            for (let i in element.pAttrValue) {
              if (!['key', 'id', 'isNew'].includes(i))
                key.push(element.pAttrValue[i]);
            }
            let producKey = key.sort().join('-');
            element.key = producKey;
            form.setFieldsValue({
              [producKey]: {
                name: element.name,
                images: element.images,
                originPrice: element.originPrice,
                paymentCash: element.paymentCash,
              },
            });
          });
        }
        form.setFieldsValue({ [property]: data[property] });
      }
      form.setFieldsValue({ vi, en, attribution });
      setInit(true);
      setProduct(data);
    } catch (error) {
      console.log(error);
    }
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      console.log('Success:', values);
      const dataForm = values;
      for (let property in dataForm) {
        if (!property.includes('-')) continue;
        let indexProduct = product.productDetail.productDetail.findIndex(
          (item: any) => item.key === property
        );
        if (indexProduct !== -1) {
          product.productDetail.productDetail[indexProduct] = {
            ...product.productDetail.productDetail[indexProduct],
            name: dataForm[property].name,
            images: dataForm[property].images,
            originPrice: dataForm[property].originPrice,
            paymentCash: dataForm[property].paymentCash,
          };
        }
      }
      let dataPatch = {
        ...product,
        accumlatePointType: dataForm.accumlatePointType,
        valueAccumulatePoints: dataForm.valueAccumulatePoints
          ? parseFloat(dataForm.valueAccumulatePoints)
          : 0,
        name: dataForm.vi.name,
        description: dataForm.vi.description,
        shortDescription: dataForm.vi.shortDescription,
        images: dataForm.images,
        categoryId: dataForm.categoryId,
        originPrice: dataForm.originPrice,
        paymentCash: dataForm.paymentCash,
        hotSequence: dataForm.hotSequence,
        translations: [
          {
            language: 'vi',
            name: dataForm.vi.name,
            description: dataForm.vi.description,
            shortDescription: dataForm.vi.shortDescription,
          },
          {
            language: 'en',
            name: dataForm.en?.name || '',
            description: dataForm.en?.description || '',
            shortDescription: dataForm.en?.shortDescription || '',
          },
        ],
      };

      const rs: any = await helper.callPageApi(
        pageInfo,
        'update_product',
        dataPatch
      );
      if (rs.status !== 200 && rs?.data?.code !== 0) throw rs;
      helper.alert('Cập nhật sản phẩm thành công');
      props.onClose();
    } catch (error: any) {
      console.log(error);
      if (error.message) {
        message.error(error.message);
      }
      if (error.response?.data?.errors) {
        message.error(error.response.data.errors);
      }
      helper.alert('Cập nhật sản phẩm thất bại');
    }
    setLoading(false);
  };
  if (!init) return <Loading />;

  return (
    <Form form={form} name='dynamic_form_complex' onFinish={onFinish}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            zIndex: 1,
            backgroundColor: 'rgba(0,0,0,.25)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loading />
        </div>
      )}
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            name='images'
            labelCol={{ span: 4 }}
            labelAlign='left'
            label='Ảnh bìa'
            rules={[{ required: true }]}
          >
            <Image multiple />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='categoryId'
            labelCol={{ span: 4 }}
            labelAlign='left'
            label='Danh mục'
            rules={[{ required: true }]}
          >
            <SingleSelect
              schema={{
                pageId: PAGE_ID,
                api: 'get_categories',
                modelSelectMultiple: false,
              }}
              placeholder='Chọn danh mục'
            />
          </Form.Item>
        </Col>
      </Row>
      <Tabs defaultActiveKey='1'>
        <Tabs.TabPane tab='Tiếng Việt' key='vi'>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name={['vi', 'name']}
                label='Tên sản phẩm'
                labelCol={{ span: 4 }}
                labelAlign='left'
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name={['vi', 'shortDescription']}
                label='Miêu tả ngắn'
                labelCol={{ span: 4 }}
                labelAlign='left'
              >
                <RichText height={210} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name={['vi', 'description']}
                label='Miêu tả'
                labelCol={{ span: 4 }}
                labelAlign='left'
                rules={[{ required: true }]}
              >
                <RichText height={210} />
              </Form.Item>
            </Col>
          </Row>
        </Tabs.TabPane>
        <Tabs.TabPane tab='Tiếng Anh' key='en'>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name={['en', 'name']}
                label='Tên sản phẩm'
                labelCol={{ span: 4 }}
                labelAlign='left'
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name={['en', 'shortDescription']}
                label='Miêu tả ngắn'
                labelCol={{ span: 4 }}
                labelAlign='left'
              >
                <RichText height={210} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name={['en', 'description']}
                label='Miêu tả'
                labelCol={{ span: 4 }}
                labelAlign='left'
                rules={[{ required: true }]}
              >
                <RichText height={210} />
              </Form.Item>
            </Col>
          </Row>
        </Tabs.TabPane>
      </Tabs>
      <Row>
        <Col span={12}>
          <Form.Item name='accumlatePointType' label='Loại tích'>
            <Radio.Group>
              {/* <Radio value='value'> Giá trị (VNĐ) </Radio>
              <Radio value='percent'> Phần trăm (%) </Radio> */}
              <Radio value='miles'> Dặm (mile) </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues, curValues) => {
              return !_.isEqual(
                prevValues.accumlatePointType,
                curValues.accumlatePointType
              );
            }}
          >
            {() => {
              const isPercent =
                form.getFieldValue('accumlatePointType') === 'percent';
              return (
                <Form.Item
                  name='valueAccumulatePoints'
                  label={`Giá trị tích ${isPercent ? '(%)' : ''}`}
                >
                  <InputNumber
                    min={0}
                    max={isPercent ? 100 : undefined}
                    style={{ width: 200 }}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        {/* <Col span={6}>
          <Form.Item
            name="price"
            label="Giá nhập"
            labelCol={{ span: 8 }}
            labelAlign="left"
            // rules={[{ required: true }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col> */}
        <Col span={6}>
          <Form.Item
            name='originPrice'
            label='Giá gốc'
            labelCol={{ span: 8 }}
            labelAlign='left'
            // rules={[{ required: true }]}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name='paymentCash'
            label='Giá bán'
            labelCol={{ span: 8 }}
            labelAlign='left'
            // rules={[{ required: true }]}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name='hotSequence'
            label='Thứ tự'
            labelCol={{ span: 4 }}
            labelAlign='left'
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>
      <Attribution
        attribution={attribution}
        setAttribution={setAttribution}
        form={form}
      />
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) => {
          return !_.isEqual(prevValues.attribution, curValues.attribution);
        }}
      >
        {() => <TableProduct form={form} />}
      </Form.Item>
      <Space
        style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}
      >
        <Button type='dashed' icon={<LeftOutlined />}>
          Quay lại
        </Button>
        <Button type='primary' icon={<PlusOutlined />} htmlType='submit'>
          Lưu dữ liệu
        </Button>
      </Space>
    </Form>
  );
}
